import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mockData';
import { Card, CardContent } from './ui/card';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it. See what our satisfied customers have to say about our services.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id} className="hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-orange-200">
              <CardContent className="pt-6">
                {/* Quote Icon */}
                <div className="mb-4">
                  <Quote className="text-orange-600" size={32} />
                </div>

                {/* Rating */}
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="text-orange-500 fill-orange-500" size={18} />
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="text-gray-700 mb-6 leading-relaxed">
                  "{testimonial.text}"
                </p>

                {/* Customer Info */}
                <div className="border-t border-gray-200 pt-4">
                  <p className="font-bold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Overall Rating Display */}
        <div className="bg-gradient-to-r from-orange-600 to-orange-500 rounded-2xl p-8 text-center text-white">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8">
            <div>
              <div className="text-6xl font-bold mb-2">5.0</div>
              <div className="flex items-center gap-1 justify-center mb-2">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="text-white fill-white" size={24} />
                ))}
              </div>
              <p className="text-orange-100">Overall Rating</p>
            </div>
            <div className="h-20 w-px bg-orange-400 hidden md:block"></div>
            <div className="text-left">
              <p className="text-2xl font-bold mb-1">500+ Happy Customers</p>
              <p className="text-orange-100">Trusted by the Manitowoc community since 2019</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
